import { Card, Collapse, Grid, Title } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import React from 'react'

import { Basic } from './Basic'
import { Controlled } from './Controlled'
import { Disabled } from './Disabled'
import { Size } from './Size'

export const InputComponentsDemo: React.FC = () => {
    const [opened, { toggle }] = useDisclosure(true)
    return (
        <Card withBorder>
            <Title order={2} onClick={toggle}>
                输入框
            </Title>
            <Collapse in={opened}>
                <Grid gutter={20}>
                    <Grid.Col span={6}>
                        <Basic />
                    </Grid.Col>
                    <Grid.Col span={6}>
                        <Size />
                    </Grid.Col>
                    <Grid.Col span={6}>
                        <Controlled />
                    </Grid.Col>
                    <Grid.Col span={6}>
                        <Disabled />
                    </Grid.Col>
                </Grid>
            </Collapse>
        </Card>
    )
}
